
import tooltip from '@/core/charts/components/tooltip-standard'

export default {
  chartType: 'Pie',
  showInChartLegend: true,
  chartOpts: getOptions(),
  chartData: (widget, data) => getChartData(data),
  chartInfo: (widget, data) => getChartInfo(data),

  colors: {
    Preferred: 3,
    Other: 1,
    Approved: 5
  },

  components: {
    tooltip
  }
}

function getOptions() {
  let baseCustSet = {
    chartGroupValue: 'Supplier Type',
    showTotal: true,
    isGaugeChart: true,
    chartInfoTooltip: true,
    hasDrillDown: false,
    containterStyle: 'height: 220px; margin-top: 10px; margin-left: 1px; margin-bottom: -100px; pointer-events: none',
    tooltip: {
      width: '190px'
    }
  }
  let baseOpts = {
    customSettings: baseCustSet,
    donut: true,
    donutWidth: 50,
    startAngle: 270,
    total: 0,
    width: '290px'
  }
  return baseOpts
}

function getChartInfo(data) {
  let result = prepareData(data).map(k => k[1])
  return result
}

function getChartData(data) {
  let datagrouped = prepareData(data)
  let labelsGrouped = datagrouped.map(k => k[0])
  let seriesGrouped = datagrouped.map(k => k[1])
  let total = seriesGrouped.reduce((partialSum, a) => partialSum + a)
  return {
    labels: labelsGrouped,
    series: seriesGrouped.map(q => Math.abs(q)),
    total: total,
    labelData: seriesGrouped,
    tooltipData: {
      metadata: tooltipMetadata,
      data: [
        labelsGrouped.map(k => k + ' Suppliers'),
        seriesGrouped,
        seriesGrouped.map(k => ((k * 100) / total).toFixed(2))
      ]
    }
  }
}

function prepareData(data) {
  let datagrouped = []
  let sortedData = []
  let a
  let o
  let p
  data.forEach(elem => {
    if (elem[0] !== 'Approved' && elem[0] !== 'Preferred') elem[0] = 'Other'
    var pos = datagrouped.findIndex(k => k[0] === elem[0])
    if (pos === -1) datagrouped.push([elem[0], elem[1]])
    else datagrouped[pos][1] += elem[1]
  })
  datagrouped.forEach(elem => {
    if (elem[0] === 'Approved') a = elem
    else if (elem[0] === 'Preferred') p = elem
    else if (elem[0] === 'Other') o = elem
  })
  if (p) sortedData.push(p)
  if (a) sortedData.push(a)
  if (o) sortedData.push(o)

  return sortedData
}

const tooltipMetadata = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: 'Payments',
    type: 'main',
    format: 'currency'
  },
  {
    label: '% of Total',
    type: 'secondary',
    format: 'percentage'
  }
]



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/PaymentsBySupplierType/chart.js